// extracted by mini-css-extract-plugin
module.exports = {"overlay":"Overlay_overlay__3_p4L","body":"Overlay_body__3Ycw5"};